import { ChartDef } from '@model-main/pivot/frontend/model/chart-def';

export const LineStyleTypes = {
    SOLID: ChartDef.LineStyleTypes.SOLID,
    DASHED: ChartDef.LineStyleTypes.DASHED,
    DOTTED: ChartDef.LineStyleTypes.DOTTED
};
